type ProfileLike = {
  firstName?: string;
  name?: string;
};

export default function formatProfileName(profile: ProfileLike) {
  if (profile.firstName) {
    return `${profile.firstName} ${profile.name}`;
  }

  if (profile.name) {
    return `${profile.name}`;
  }

  return '';
}
